import { SavedBlob } from "api/generated/model";
import { HARDCODED_BACKEND_PATHS } from "utils/hardcodedBackendPaths";

import { FileExtensionWhiteList, UploaderFile } from "./types";

export const FILE_SIZE_LIMIT = 209715200;
export const MAX_FILES = 5;

export const WARN_EXTENSIONS: Set<string> = new Set([
    ".msg",
    ".eml",
    ".xls",
    ".xlsm",
    ".xlsb",
    ".xml",
    ".doc",
    ".docm",
    ".zip",
    ".7z",
    ".mdb",
    ".accdb",
    ".accde",
    ".accdt",
    ".accdr",
    ".sdf",
    ".htm",
    ".html",
    ".vdx",
    ".vsd",
    ".vsdm",
    ".vsdx",
    ".vsl",
    ".vss",
    ".vssm",
    ".vssx",
    ".vst",
    ".vstm",
    ".vstx",
    ".vsw",
    ".vsx",
    ".vtx",
    ".mp4",
    ".edoc",
]);

export const matchesFileExtensionWhiteList = (
    whiteList: FileExtensionWhiteList,
    fileName: string
): boolean => {
    const extension = fileName
        .replace(/^.*?(\.([^\.]*))?$/, "$2")
        .toLowerCase()
        .trim();
    return whiteList.includes(extension);
};

export const mapCommonFields = (file: File) => ({
    fileName: file.name,
    lastModified: formatLastModified(file.lastModified),
    fileSize: file.size,
    fileType: file.type,
});

export const matchesWhitelist = (
    whitelist: FileExtensionWhiteList,
    fileName: string
) => matchesFileExtensionWhiteList(whitelist, fileName);

export const validFileSize = (fileSize: number) => fileSize < FILE_SIZE_LIMIT;

export const formatLastModified = (lastModified: number) =>
    new Date(lastModified).toString();

export const formatBlobUrl = (blobId: string) =>
    `${HARDCODED_BACKEND_PATHS.BLOBS}/${blobId}`;

export function savedBlobToUploaderFile(blob: SavedBlob): UploaderFile {
    return {
        status: "done",
        id: blob.id,
        keyId: blob.id,
        url: formatBlobUrl(blob.id),
        fileName: blob.fileName,
        fileSize: blob.fileSize,
        fileType: blob.fileType,
        lastModified: blob.lastModified,
    };
}
